import { Sparkles } from "lucide-react";

function tone(score) {
  if (score == null) return null;
  if (score >= 85) return { bg: "bg-moss", text: "text-canvas", label: "match" };
  if (score >= 65) return { bg: "bg-terracotta", text: "text-canvas", label: "match" };
  if (score >= 45) return { bg: "bg-subtle", text: "text-ink", label: "match" };
  return { bg: "bg-subtle", text: "text-muted2", label: "match" };
}

export default function MatchBadge({ score, size = "sm" }) {
  const t = tone(score);
  if (!t) return null;
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      data-testid={`match-badge-${score}`}
      className={`inline-flex items-center gap-1 rounded-full ${pad} font-medium ${t.bg} ${t.text}`}
      title="Based on your focus tags, pillar priorities, and personas."
    >
      <Sparkles className="h-3 w-3" strokeWidth={2} />
      {score}% {t.label}
    </span>
  );
}
